(function () {
    'use strict';

    function subscriptionsRouteConfig($stateProvider) {
        $stateProvider
            .state('subscriptions.signup', {
                url: '/entities/subscriptions/signup/plans/*planId',
                templateUrl: 'subscriptions/templates/signup.html',
                controller: 'subscriptionSignupController',
                controllerAs: 'ctrl',
                resolve: {
                    plans: [],
                    sessionData: ["sessionDataService", function(sessionDataService) {
                        return sessionDataService.loadSession().then(function(data) {
                            return data;
                        });
                    }]
                }
            });
    }

    subscriptionsRouteConfig.$inject = ['$stateProvider'];

    angular.module('ecap.subscriptions').config(subscriptionsRouteConfig);
})();